import { Controller } from "@hotwired/stimulus"
import ga from "../utils/ga"
import { Consent, userHasOptedOutOfCookiesForCategory } from "../utils/consent"
import Cookies from "js-cookie"

export default class extends Controller {
  static targets = ["variant", "cover"]
  static experimentsConfig

  initialize() {
    if (!this.userRevokedExperimentsConsent()) {
      this.reportGA()
    }
  }

  userRevokedExperimentsConsent() {
    return userHasOptedOutOfCookiesForCategory(Consent.preferences)
  }

  reportGA() {
    let gaValue

    // eslint-disable-next-line banhammer/no-restricted-functions
    const clientCookieValue = Cookies.get("mk_ex")
    const serverCookieValue = document.body.dataset.experimentEnrolments

    if (clientCookieValue === serverCookieValue) {
      // Google Optimize needs the experiment string to be delimited with a ! instead of a *.
      // We convert it here before logging it to Google Analytics.
      gaValue = serverCookieValue.replace(/\*/g, "!")
    }
    if (!gaValue) {
      gaValue = null
    }

    ga("set", "exp", gaValue)
    ga("set", "dimension21", gaValue)
    ga("set", "dimension22", gaValue)
  }
}
